import './styles/Autocomplete.scss';
import Autocomplete from './js/Autocomplete';
export default Autocomplete;